const USER_STORAGE_KEY = 'authUser';
let refreshInFlight: Promise<boolean> | null = null;

export const isAuthenticated = () => {
    return getUser() !== null;
};

export const logout=()=>{
    localStorage.removeItem(USER_STORAGE_KEY);
    void fetch('/api/Auth/logout', { method: 'POST', credentials: 'include' });
}

export interface User {
    username: string;
    email: string;
    isAdmin: boolean;
}

export const getUser = (): User | null => {
    try {
        const storedUser = localStorage.getItem(USER_STORAGE_KEY);
        return storedUser ? JSON.parse(storedUser) as User : null;
    } catch {
        return null;
    }
};

export const storeUser = (user: User) => {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const loadCurrentUser = async (): Promise<User | null> => {
    try {
        const response = await fetch('/api/Auth/me', { credentials: 'include' });
        if (!response.ok) {
            return null;
        }

        const user = await response.json() as User;
        storeUser(user);
        return user;
    } catch {
        return null;
    }
};

export const refreshAccessToken = async (): Promise<boolean> => {
    if (refreshInFlight) {
        return refreshInFlight;
    }

    refreshInFlight = (async () => {
        try {
            const response = await fetch('/api/Auth/refresh', {
                method: 'POST',
                credentials: 'include'
            });
            if (!response.ok) {
                localStorage.removeItem(USER_STORAGE_KEY);
                return false;
            }

            const data = await response.json();
            storeUser(data.user);
            return true;
        } catch {
            localStorage.removeItem(USER_STORAGE_KEY);
            return false;
        }
    })();

    try {
        return await refreshInFlight;
    } finally {
        refreshInFlight = null;
    }
};